define('v3/Common/Services/Frontend/Mask.Service',[
	'knockout',
	'jquery'
], function (ko, $) {
	var defaults = {
		loader: '#loader-container .loader',
		template: '<div class="mask mask-service" data-bind="stopBinding: {}"></div>',
		appendTo: $('.main > div:not(.tab-container)'),
		defaultAppendTo: '.main > div:not(.tab-container)'
	};

	var getOptions = function (elm) {
		if (elm) {
			return $.extend({}, defaults, {
				appendTo: (elm instanceof $) ? elm : $(elm)
			});
		} else {
			return defaults;
		}
	};

	return {

		showMask: function (elm, vm) {
			var options = getOptions(elm);
			var loader = $(options.loader);
			var mask;

			if (options.appendTo.selector === options.defaultAppendTo) {
				mask = $(options.template).insertAfter(options.appendTo);

				// Hide elements (not mask and tabs) with a class and set visiblity:hidden and height: 0
				// This is for sticky header to get the right coordinates
				var hidden = $(options.appendTo.selector + ':not(.mask, .tab-container):visible').addClass('hidden-by-mask');

				// Store all hidden elements that where visible, so that hiding the mask will make them visible again
				mask.data('mask', hidden);
			} else {
				mask = $(options.template).appendTo(options.appendTo);
			}

			// Add a class to the body that will control some pointer-events, (e.g. disabling tabs)
			$('body').addClass('mask-active');

			var clone = loader.clone().addClass('loader-clone').appendTo(mask);
			$(elm).addClass('has-mask');

			if (vm) {
				ko.applyBindings(vm, clone.get(0));
			} else {
				ko.applyBindings({}, clone.get(0));
			}
		},

		hideMask: function (elm) {
			var options = getOptions(elm);

			if (options.appendTo.selector === options.defaultAppendTo) {
				$('.mask.mask-service').each(function (ind, elm) {
					var hidden = $(elm).data('mask');
					if (hidden) {
						hidden.removeClass('hidden-by-mask');
					}

					$(elm).data('mask', null);
					$('.mask.mask-service').remove();
				});
			} else {
				options.appendTo.find('.mask.mask-service').remove();
			}

			$('body').removeClass('mask-active');
			$(elm).removeClass('has-mask');
		},

		toggleMask: function (elm, vm) {
			var options = getOptions(elm);

			if (options.appendTo.find('.loader-clone').length > 0) {
				this.hideMask(elm);
			} else {
				this.showMask(elm, vm);
			}
		},

		showLoader: function (elm) {
			var options = getOptions(elm);
			var loader = $(options.loader);

			loader.clone().addClass('loader-clone').appendTo(options.appendTo);
		},

		hideLoader: function (elm) {
			var options = getOptions(elm);

			options.appendTo.find('.loader-clone').remove();
		},

		toggleLoader: function (elm) {
			var options = getOptions(elm);

			if (options.appendTo.find('.loader-clone').length > 0) {
				this.hideLoader(elm);
			} else {
				this.showLoader(elm);
			}
		},

		tinyLoader: {
			show: function (elm) {
				if ($(elm).find('.tiny-loader').length === 0) {
					$('<div class="tiny-loader"></div>').appendTo(elm);
				}
			},
			hide: function (elm) {
				$(elm).find('.tiny-loader').remove();
			},
			toggle: function (elm) {
				if ($(elm).find('.tiny-loader').length > 0) {
					this.hide(elm);
				} else {
					this.show(elm);
				}
			}
		}
	};
});

